import { isMobile  } from '@utils/index.js'
export class Scene {
    constructor({el}) {
        this.DOM = {
            clas: el,
            el: $(el),
            tabItems: $(el).find('.tab-item'),
            tabPanes: $(el).find('.tab-pane'),
        }
        this.init()
    }
    onEvent() {
        const that = this
        // TAb切换
        $(`${this.DOM.clas} .tab-item`).on('click', function(e) {
            const name = $(this).data('name');
            $(this).addClass('is-active');
            $(this).siblings().removeClass('is-active');

            $(`${that.DOM.clas} .tab-pane[data-name="${name}"]`).addClass('tab-pane-active')
            $(`${that.DOM.clas} .tab-pane[data-name="${name}"]`).siblings().removeClass('tab-pane-active')

            const container = $(`${that.DOM.clas} .tab-contain`).get(0);
            const parentRect = container.getBoundingClientRect();
            if (isMobile()) {
                const elementRect = $(this).get(0).getBoundingClientRect()
                if (elementRect.left - parentRect.left < 0) {
                    const left = $(`${that.DOM.clas} .tab-contain`).scrollLeft() + elementRect.x - parentRect.x
                    $(`.tab-contain`).animate({
                        scrollLeft: left
                    }, 200);
                }

                if(elementRect.right - parentRect.right > 0) {
                    const left = $(`${that.DOM.clas} .tab-contain`).scrollLeft() - parentRect.right + elementRect.right
                    $(`.tab-contain`).animate({
                        scrollLeft: left
                    }, 200);
                }

            }
            const anchorActive = $('.sticky_anchor_active').get(0).getBoundingClientRect()
            if (parentRect.top - anchorActive.height < 2) {
                $('html, body').animate({
                    scrollTop: $('.tabs-content').offset().top - parentRect.top - anchorActive.height
                }, 200)
            }
            let pareBox = this.closest('.empty-block-box');
            let prevBox = pareBox ? pareBox.previousElementSibling : null;
            let text = prevBox ? prevBox.querySelector('.text')?.textContent.trim() : '未找到';
            let navTitle = document.documentElement.clientWidth < 1024 ? $('.five-kwh-tab .jky-tabs-item.active').text():$('.five-kwh-tab .navli.active').text();
            const gaParams = {
                module: 'Directory',
                position: navTitle,
                title: text,
                content: name,
            }
            that.handleGAEvent(gaParams)

        })

        // view-more点击
        $(`${this.DOM.clas} .scene-view-more`).click(function() {
            const index = $(this).data('index')
            $(`${that.DOM.clas} .scene-text-content-${index}`).addClass('scene-expanded')
            $(this).hide()
            $(`${that.DOM.clas} .scene-view-collapse-${index}`).css({'display': 'flex'})
        })
        $(`${this.DOM.clas} .scene-view-collapse`).click(function() {
            const index = $(this).data('index')
            $(`${that.DOM.clas} .scene-text-content-${index}`).removeClass('scene-expanded')
            $(this).hide()
            $(`${that.DOM.clas} .scene-view-more-${index}`).css({'display': 'flex'})
        })

    }
    // 埋码
    handleGAEvent(params) {
        // 埋码
        window.dataLayer.push({ "event_parameters": null });
        window.dataLayer.push({
            event:"ga4Event",
            event_name:"new_education_user_clicks",
            event_parameters:{
                current_page: window.location.href,
                ...params
            }
        });
    }
    init() {
        this.onEvent()
    }
}
